export const environment = {
  production: false,
  panel: 'mango_',
  domain: "2023exch.com",
  baseUrl: "https://api.2023exch.com",
  trafficTag: '',
  pollers: {
    oddsData: 600,
    listOddsData: 10000,
    scoresData: 1000,
  },
  noDataMsg: 'No Data Found',
  isMobile: true,
  isBetOpenEnv: false,
  stakes: { "stake_name_1": "100", "stake_name_2": "5000", "stake_name_3": "500", "stake_name_4": "25000", "stake_name_5": "50000", "stake_name_6": "100000", "stake_name_7": "500000", "stake_name_8": "1000000", "stake_amount_1": 100, "stake_amount_2": 5000, "stake_amount_3": 500, "stake_amount_4": 25000, "stake_amount_5": 50000, "stake_amount_6": 100000, "stake_amount_7": 500000, "stake_amount_8": 1000000 },
  horseRaceJockeyImgPrefix: 'https://content-cache.cdnbf.net/feeds_images/Horses/SilkColours/',
  desktopStyles: [],
  mobileStyles: [],
  host: {
    domain: '',
    name: '',
    dName: '',
    ext: '',
    theme: '',
    email: '',
    phone:'',
    demoLogin: false,
    ftLivetvData: '',
    iframeDomainUrl: '',
    signUpActive: false,
    depoWithdraw: false,
    chatActive:true,
    celeb:true,
    social: {
      isShow: false,
      facebook: '',
      whatsapp: '',
      telegram: '',
      instagram: '',
      youtube:'',
    },
    pusher: {
      key: '',
      cluster: ''
    },
    mThemePath: [''],
    dThemePath: [''],
    afterLoginNoticePath: '',
  },
  hosts: [
    {
      domain: 'localhost',
      name: 'localhost',
      dName: 'LocalHost',
      ext: '.com',
      theme: 'blue-body',
      email: 'contactmybetbhai@gmail.com',
      phone:'',
      demoLogin: true,
      ftLivetvData: 'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
      iframeDomainUrl: 'https://77panel.com/',
      signUpActive: true,
      depoWithdraw: true,
      chatActive:true,
      celeb:true,
      social: {
        isShow: false,
        facebook: '',
        whatsapp: '',
        telegram: '',
        instagram: '',
        youtube:'',
      },
      pusher: {
        key: '40928c154aa1ed0c1c8d',
        cluster: 'ap2'
      },
      mThemePath: [],
      dThemePath: [],
      afterLoginNoticePath: '',
    },
    {
      domain: 'mango777.win',
      name: 'mango777',
      dName: 'mango777',
      ext: '.win',
      theme: 'blue-body',
      email: 'contactmybetbhai@gmail.com',
      phone:'',
      demoLogin: true,
      ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      iframeDomainUrl: 'https://77panel.io/',
      signUpActive: true,
      depoWithdraw: true,
      chatActive:true,
      celeb:true,
      social: {
        isShow: true,
        facebook: 'https://www.facebook.com/Mango777-103350852235733/',
        whatsapp: 'https://wa.me/447478877777',
        telegram: 'https://t.me/mango777_official',
        instagram: 'https://instagram.com/mango777_official?igshid=MzRlODBiNWFlZA==',
        youtube:'https://www.youtube.com/channel/UCmvxIj8Wsnr3kMI3lua18M',
      },
      pusher: {
        key: '4ae8dfadca375e6d7f9f',
        cluster: 'eu'
      },
      mThemePath: [],
      dThemePath: [],
      afterLoginNoticePath: '',
    },
    {
      domain: 'mango777.io',
      name: 'mango777',
      dName: 'mango777',
      ext: '.io',
      theme: 'blue-body',
      email: 'mango777online@gmail.com',
      phone:'+44 74788 77777',
      demoLogin: true,
      ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      iframeDomainUrl: 'https://77panel.io/',
      signUpActive: true,
      depoWithdraw: true,
      chatActive:true,
      celeb:true,
      social: {
        isShow: true,
        facebook: 'https://www.facebook.com/Mango777-103350852235733/',
        whatsapp: 'https://wa.me/447478877777',
        telegram: 'https://t.me/mango777_official',
        instagram: 'https://instagram.com/mango777_official?igshid=MzRlODBiNWFlZA==',
        youtube:'https://www.youtube.com/channel/UCmvxIj8Wsnr3kMI3lua18M',
      },
      pusher: {
        key: '4ae8dfadca375e6d7f9f',
        cluster: 'eu'
      },
      mThemePath: [],
      dThemePath: [],
      afterLoginNoticePath: 'https://sthiracdn.com/assets/mangoo777-client/popup-newlink1.jpg',
    },
    {
      domain: 'royal247.bet',
      name: 'royal247',
      dName: 'royal247',
      ext: '.bet',
      theme: 'blue-body',
      email: '',
      phone:'',
      demoLogin: true,
      ftLivetvData: 'https://getscoredata.com/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      iframeDomainUrl: 'https://77panel.io/',
      signUpActive: true,
      depoWithdraw: true,
      chatActive:false,
      celeb:false,
      social: {
        isShow: false,
        facebook: '',
        whatsapp: '',
        telegram: '',
        instagram: '',
        youtube:'',
      },
      pusher: {
        key: '30d84d922854368d449e',
        cluster: 'eu'
      },
      mThemePath: [],
      dThemePath: [],
      afterLoginNoticePath: '',
    },
  ],
};
